import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  CameraIcon,
  FileTextIcon,
  HistoryIcon,
  ImageIcon,
  MoreVerticalIcon,
  Trash2Icon,
} from "lucide-react";

export interface ReportActionHandlers {
  onRevert: () => void;
  onSaveSnapshot: () => void;
  onExportCsv: () => void;
  onExportPng: () => void;
  onRemoveFromPage?: () => void;
  isSystemReport?: boolean;
}

interface ReportActionMenuProps {
  id?: string;
  actions: ReportActionHandlers;
}

export const ReportActionMenu: React.FC<ReportActionMenuProps> = ({
  id,
  actions,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="p-2 hover:bg-accent rounded-full">
          <MoreVerticalIcon className="h-5 w-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={actions.onRevert} disabled={!id}>
          <HistoryIcon className="mr-2 h-4 w-4" />
          <span>Revert to last save</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={actions.onSaveSnapshot} disabled={!id}>
          <CameraIcon className="mr-2 h-4 w-4" />
          <span>Save Snapshot</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={actions.onExportCsv}>
          <FileTextIcon className="mr-2 h-4 w-4" />
          <span>Export as CSV</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={actions.onExportPng}>
          <ImageIcon className="mr-2 h-4 w-4" />
          <span>Export as PNG</span>
        </DropdownMenuItem>
        {actions.onRemoveFromPage && (
          <DropdownMenuItem
            onClick={actions.onRemoveFromPage}
            className="text-red-600 focus:text-red-600"
            disabled={actions.isSystemReport}
          >
            <Trash2Icon className="mr-2 h-4 w-4" />
            <span>Remove from Workspace</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
